import React, { Component } from 'react';
import { createContainer } from '@dbk-legacy/muster/react';
import { Settings } from '@dbk/ui-icons';
import Text from '@dbk/ui-text';
import { LoadingCircle } from '../../components/common/loading';
import HeaderComponent from './header-component';
import SubInvestment from './sub-investment';
import InvestmentFilter from './investment-filter';
import BlurModal from '../../components/common/blur-modal/blur-modal';
import ErrorPopup from './error-toast';
import {INVESTMENT_API_CODES,PALETTE} from '../../constants';






var count = 0;
let headerTitle;
class InvestmentIdeas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      records: [],
      openModal: false,
      selectedAssets:[],
      selectedAction:[],
      openErrorToast: false,
      applyClicked: false,
      badgeCount: 0
    }
  }

  componentDidMount() {
    if (this.props.investment.fromDetailsPage && this.props.investment.getSelectedAssetsActions!=='') {
      const getData = this.props.investment.getSelectedAssetsActions
      this.props.getInvestmentData(getData[0], getData[1]);
      const count = getData[0].length +  getData[1].length;
      this.setState({badgeCount: count, applyClicked: true})
    }
    else
      this.props.getInvestmentData([], []);
  }

  componentWillUnmount(){
    this.props.clearInvestmentData("")
    this.props.setDetailsPage(false);
   }

   filterApplyClick =async ()=>{
    await this.setState({applyClicked: true, badgeCount: count})
    this.setState({ openModal: false},()=>this.props.clearInvestmentData(""))
    const assetsvalues = this.state.selectedAssets.map((item)=>item.value)
    const actionsvalue = this.state.selectedAction.map((item)=>item.value)
    this.props.setFilterData([assetsvalues,actionsvalue])
    await this.props.getInvestmentData(assetsvalues, actionsvalue)
   }



   closeBlurModel = async () => {
    this.setState({selectedAssets: [], selectedAction: []});
   this.setState({ openModal: false});
   }

   itemClicked=(item)=>{

    this.props.changePage({pathname: '/investments/details/' + item.articleId})
   }

   itemClick = async () => {
    await this.setState({selectedAssets: [], selectedAction: []});
    await this.setState({openModal: true});

   }

   handleOnChangeAsset = (selectedItem, selectedAssets) => {
    this.setState({
      selectedAssets
    });
    this.filterCount();
}

handleOnChangeAction = (selectedItem, selectedAction) => {
  this.setState({
      selectedAction
  });
  this.filterCount();
}

filterCount = () => {
  var assestCount = Object.keys(this.state.selectedAssets).length;
  var actionCount = Object.keys(this.state.selectedAction).length;
  count =  assestCount + actionCount;
}

clearClicked = async () => {
  await this.setState({ selectedAssets:[],
      selectedAction:[]})
    this.filterCount();
}

onCloseToast = async () => {
  this.props.changePage('/portfolios');
}

onErrorOccured = () => {
  this.setState({openModal: false}, ()=> this.setState({openErrorToast: true}));
    
}

renderHeader = () => {
  const {
    i18n : {messages}
  } = this.props;
  return (
    <div>
    <div className="header-div">
    <div className="title-div">{messages['app.common.pageTitle.investmentsIdeas']}</div>
    <div className="filter-div">
      <a className="inner-filter" onClick={()=> this.itemClick()}>
        <Settings width={20} height={20} color={PALETTE.secondaryActive} />
        {this.state.applyClicked?
        <Text className="filter-text">{`${messages['app.investment.filter.title']} (${this.state.badgeCount})`}</Text>: <Text className="filter-text">{messages['app.investment.filter.title']}</Text>
        }
      </a>
    </div>
  </div>

    {this.state.openModal &&  <BlurModal
        onDone = {this.closeBlurModel}
        visible={this.state.openModal}
        headerChildren={headerTitle}
        size="small"
      >
     
     <InvestmentFilter filterApplyClick={this.filterApplyClick} selectedAssets={this.state.selectedAssets} selectedAction={this.state.selectedAction} handleOnChangeAsset={this.handleOnChangeAsset} handleOnChangeAction={this.handleOnChangeAction} totalCount={count} clearClicked={this.clearClicked} onErrorClosed={this.onErrorOccured}/>
    </BlurModal>} 
    
       {this.state.openErrorToast &&  (<div style={{position: 'absolute', alignItems: 'stretch', width: '70%'}}>
        <ErrorPopup header={messages['app.investment.connection.error']} message={this.props.investmentFilter.investmentFilterError} onClose={()=> this.setState({openErrorToast: false})} containerStyle={{paddingTop: 300,paddingLeft: "40%", position: 'absolute' }}/>
       </div>)}
       </div>
  );
}

  render() {
    const {
      i18n : {messages},
      ui: {investmentData}
    } = this.props;
    this.filterCount();
    headerTitle = `${messages['app.investment.filter.title']}(${count})`
    if (investmentData !== "" && investmentData.status === "SUCCESS") {
      this.props.clearInvestmentError("");
      if(investmentData.data === null){
        return (
         <div>
           {this.renderHeader()}
           <div className="no-idea-container">
            <div className="no-idea-text">{messages['app.investmentIdeas.searchNoData']}</div>
          </div>
          </div>
        );
      }
      const recordsArrayObject = investmentData.data.records;
      const recordsArraySliceObject = recordsArrayObject.slice();
      const firstItem = recordsArraySliceObject.shift();

      return (

         // with styles.css
         
        <div className="container">
          {this.renderHeader()}
          <div className="investment-image-container">
          <HeaderComponent item={firstItem} itemClick={() => this.itemClicked(firstItem)} />
          <SubInvestment items={recordsArraySliceObject} />
          </div>
      </div> 
        )
    }
    else if(this.props.ui.investmentAPIError){
      return (
        <div>
          <ErrorPopup  header={messages['app.investment.connection.error']} message={this.props.ui.investmentAPIError} onClose={this.onCloseToast}containerStyle={{paddingTop: 200,paddingLeft: "30%", width: "70%"}}/>
        </div>
      );
    }
    return (
      <div className="pad-bottom-30"> 
        <LoadingCircle />
      </div>
    );
  }

}
export default createContainer({
  $queries: {
    i18n : {
      messages:true
    },
    getInvestmentData: {
      $call: 'getInvestmentData'
    },
    clearInvestmentError: {
      $set: 'ui.investmentAPIError'
    },
    ui :{
      investmentData : true,
      investmentAPIError: true
    },
    investment:{
      getSelectedAssetsActions: true,
      fromDetailsPage:true,
    },
    setFilterData:{
      $set:'investment.getSelectedAssetsActions'
    },
    clearInvestmentData : {
      $set: 'ui.investmentData'
    },
    changePage: { 
      $call: 'ui.history.push' 
    },
    investmentFilter: {
      investmentFilterError: true,
    },
    setDetailsPage: {
      $set: 'investment.fromDetailsPage',
    },
  },
})(InvestmentIdeas);
